export const brand = {
  name: 'Protocolo Septiembre Amarillo™',
  short: 'PROTOCOLO SEPTIEMBRE AMARILLO',
  tag: 'Solución profesional para salud mental',
}

export const checkoutUrl = 'https://mi-mejor-version.impultienda.ar'

export const mockups = {
  kit: 'https://cdn.magicpatterns.com/uploads/1riMt5zQhHGL4U1CQQAZ4u/mockup.png',
  deck: 'https://cdn.magicpatterns.com/uploads/wXByFHTzuPkPSPUnXjjebj/prod2.png',
  deckCards: 'https://cdn.magicpatterns.com/uploads/e3Vv3MXTxHdiuccudzJMYR/prod1-2.png',
  cardsGifts: 'https://cdn.magicpatterns.com/uploads/28VDYkN3tgbRhyqzMqd9dH/prod2-2.png',
  bookmarksDetail: 'https://cdn.magicpatterns.com/uploads/hqn2hbiParghRahX3GDoh6/prod3-2.png',
  cards: 'https://cdn.magicpatterns.com/uploads/fEatAaVzUWT2rRUQGWqoyK/prod1.png',
  bookmarks: 'https://cdn.magicpatterns.com/uploads/o6viRfMWWCydrygAR9a32g/1.png',
}

export const heroFacts: string[] = [
  'Acceso inmediato',
  '50 páginas',
  '300+ elementos',
  'Kit 3 en 1',
]

export interface Quote {
  initials: string
  quote: string
  author: string
  role: string
  city: string
}

export const quickQuotes: Quote[] = [
  {
    initials: 'MG',
    quote:
      'Tenía 3 horas para preparar mi charla. Con este kit imprimí, organicé y entregué material profesional. Mis alumnos preguntan si hay más.',
    author: 'Lic. María González',
    role: 'Psicóloga',
    city: 'CABA',
  },
  {
    initials: 'CR',
    quote:
      'Como docente, esto me ahorró horas de buscar en Google. Viene todo: el mazo, las tarjetas, los marcadores. Listo para usar.',
    author: 'Prof. Carlos Ruiz',
    role: 'Docente Secundario',
    city: 'Córdoba',
  },
  {
    initials: 'PG',
    quote:
      'Para RRHH esto fue oro puro. Hicimos dinámicas en el equipo, entregamos los marcadores y creamos diálogo real sobre salud mental.',
    author: 'Lic. Patricia Gómez',
    role: 'Directora de Talento',
    city: 'Mendoza',
  },
  {
    initials: 'SM',
    quote:
      'El impacto fue inmediato. Los empleados no solo recibieron un papel bonito, recibieron una herramienta de contención real.',
    author: 'Lic. Sofía Martínez',
    role: 'Líder de People',
    city: 'Buenos Aires',
  },
]

export const deepQuotes: Quote[] = [
  {
    initials: 'JP',
    quote:
      'Usé el mazo en un taller con 20 adolescentes. Vi a chicos cerrados emocionalmente abrirse y hablar de cosas que nunca habían compartido. Fue transformador. Ahora pido más kits para otros grupos. Además, los bonos me ahorraron horas de preparación.',
    author: 'Lic. Juan Pérez',
    role: 'Psicopedagogo',
    city: 'La Plata',
  },
  {
    initials: 'AL',
    quote:
      'Imprimí todo en la tarde, lo usé al día siguiente. Mis 40 estudiantes se sintieron valorados al recibir algo bonito y con propósito. Algunos me dicen que lo guardaron en la billetera. Es increíble. La guía de implementación fue clave para hacerlo sin improvisar.',
    author: 'Prof. Alejandra López',
    role: 'Docente',
    city: 'Rosario',
  },
  {
    initials: 'PG',
    quote:
      'Para RRHH esto fue oro puro. Hicimos dinámicas en el equipo, entregamos los marcadores y creamos un diálogo real sobre salud mental sin sonar corporativo. El clima laboral mejoró notablemente. El kit de comunicación me ayudó a presentarlo con profesionalismo.',
    author: 'Lic. Patricia Gómez',
    role: 'Directora de Talento',
    city: 'Mendoza',
  },
  {
    initials: 'GR',
    quote:
      'Tengo consultorio de psicología hace 15 años. Nunca había visto un material tan bien pensado para abrir conversaciones difíciles. Mi cliente en crisis se llevó un marcador y me dijo que cuando lo vio, se sintió menos sola. Los 3 bonos hicieron la diferencia.',
    author: 'Lic. Gabriela Rodríguez',
    role: 'Psicóloga',
    city: 'San Isidro',
  },
]

export interface ProductImage {
  src: string
  alt: string
}

export interface Product {
  emoji: string
  eyebrow: string
  title: string
  lead: string
  body: string
  images: ProductImage[]
}

export const products: Product[] = [
  {
    emoji: '🃏',
    eyebrow: 'Producto 1',
    title: 'Mazo Reflexivo',
    lead: '36 cartas con preguntas reflexivas para hablar sobre salud mental y valorización de la vida durante la campaña del Septiembre Amarillo.',
    body: 'Con una propuesta accesible, sensible y fácil de aplicar, el material ayuda a abrir espacio para conversaciones importantes sobre salud mental, sentimientos, autocuidado, apoyo y valorización de la vida, haciendo las acciones del Septiembre Amarillo mucho más humanas y especiales.',
    images: [
      {
        src: mockups.deck,
        alt: 'Caja de la Baraja del Septiembre Amarillo junto a una carta con pregunta reflexiva durante una dinámica grupal',
      },
      {
        src: mockups.deckCards,
        alt: 'Hoja del Mazo Reflexivo con nueve cartas de preguntas numeradas vista en una tablet',
      },
    ],
  },
  {
    emoji: '💌',
    eyebrow: 'Producto 2',
    title: '120 Tarjetas de Mensajes',
    lead: 'Hacé tus acciones del Septiembre Amarillo aún más especiales.',
    body: '120 tarjetas con mensajes acogedores y motivacionales, perfectas para distribuir individualmente o transformar en lindos regalos con bombones, caramelos, pirulitos, dulces, lapiceros y mucho más. Una forma simple y amorosa de esparcir mensajes de esperanza y valorización de la vida.',
    images: [
      {
        src: mockups.cards,
        alt: 'Muestra de las 120 tarjetas de mensajes ilustradas para el Septiembre Amarillo',
      },
      {
        src: mockups.cardsGifts,
        alt: 'Tarjetas de mensajes usadas como regalos: bolsitas de caramelos con cinta amarilla y pirulitos con tarjeta',
      },
    ],
  },
  {
    emoji: '📌',
    eyebrow: 'Producto 3',
    title: '120 Marcadores de Página',
    lead: 'Un regalo lindo y afectivo para entregar en escuelas, empresas, iglesias, proyectos, charlas, grupos y acciones de concientización del Septiembre Amarillo.',
    body: 'Transformá tus acciones del Septiembre Amarillo en momentos aún más especiales, acogedores y llenos de significado. Este material reúne 120 marcadores de página con diferentes estilos, ilustraciones y mensajes de valorización de la vida, cuidado, esperanza e incentivo.',
    images: [
      {
        src: mockups.bookmarks,
        alt: 'Muestra de los 120 marcadores de página con distintos diseños y mensajes de valorización de la vida',
      },
      {
        src: mockups.bookmarksDetail,
        alt: 'Cinco marcadores de página impresos con girasoles y mensajes de esperanza sobre un escritorio de madera',
      },
    ],
  },
]

export const deliverables: string[] = [
  '20 páginas en PDF con los 120 cartones de mensajes motivacionales',
  '6 páginas del Mazo Reflexivo (36 cartas + caja para armar y guardar)',
  '24 páginas de Marcadores (120 opciones diferentes de diseños)',
  'Guía de Implementación Profesional (instrucciones paso a paso para liderar dinámicas)',
  'Todos los archivos en PDF de alta resolución listos para imprenta',
  'Los PDFs te llegan directo por email, con acceso inmediato',
  'Archivo no editable (optimizado para imprimir sin cambios)',
]

export interface Bonus {
  tag: string
  title: string
  subtitle: string
  lead: string
  includes: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bono #1',
    title: 'Guía Express de Implementación',
    subtitle: '“Campaña Lista en 30 Minutos”',
    lead: 'Convertí el Protocolo Septiembre Amarillo™ en una acción lista para aplicar en tu escuela, consultorio, empresa o institución en menos de 30 minutos.',
    includes: [
      '5 planes de uso según contexto (escuela, consultorio, empresa, iglesia, taller)',
      'Checklist de preparación previa',
      'Mini protocolo de apertura y cierre de actividad',
      'Guía de uso de tarjetas, mazo y marcadores',
      'Plan express de 30 minutos printable',
    ],
    value: '$3.990',
  },
  {
    tag: 'Bono #2',
    title: 'Checklist Profesional de Impresión y Armado',
    subtitle: '“Todo Listo para Entregar”',
    lead: 'Imprimí, recortá y presentá tu kit como si fuera un material institucional premium, sin errores, sin desperdicio y sin gastar de más.',
    includes: [
      'Tabla de materiales recomendados por contexto',
      'Guía de papeles sugeridos (gramaje, tipo, acabado)',
      'Calculadora manual de cantidades según personas',
      'Instrucciones de corte y armado',
      'Ideas de presentación y souvenirs con propósito',
      'Texto listo para enviar a la imprenta',
    ],
    value: '$2.990',
  },
  {
    tag: 'Bono #3',
    title: 'Kit de Comunicación Institucional',
    subtitle: '“Listo para Convocar y Presentar”',
    lead: 'Anunciá, presentá y acompañá tu acción de Septiembre Amarillo con mensajes profesionales listos para copiar, pegar y enviar.',
    includes: [
      '12 mensajes institucionales copiables (escuela, empresa, consultorio, comunidad)',
      'Textos para WhatsApp, email y cartelera',
      'Textos de apertura y cierre de actividad',
      'Disclaimers sensibles',
      'Mensaje post campaña',
      'Versión mobile-friendly',
    ],
    value: '$2.490',
  },
]

export const offer = {
  listPrice: '$24.990',
  price: '$14.990',
  currency: 'ARS',
  subtitle: 'Oferta de Lanzamiento | Acceso de por vida',
  detail:
    'Incluye: 50 páginas de material profesional + 3 bonos exclusivos + Guía completa de implementación + Soporte por email.',
  cta: '🟢 Comprar ahora por apenas $14.990',
}

export const trustItems = [
  { icon: 'lock', label: 'Pago 100% seguro' },
  { icon: 'check', label: 'Acceso inmediato' },
  { icon: 'money', label: 'Garantía 7 días' },
  { icon: 'mail', label: 'Soporte por email' },
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Inmediatamente después de confirmar el pago, te llegan los PDFs directo a tu email. No hay plataformas ni pasos extra: abrís el mail y ya tenés las 50 páginas + los 3 bonos para guardar o imprimir desde cualquier dispositivo (computadora, celular o tablet).',
  },
  {
    question: '¿Debo editarlos o vienen listos para imprimir?',
    answer:
      'Vienen 100% listos para imprimir. No son editables. Están optimizados en PDF para que la calidad sea impecable en cualquier imprenta. Si necesitás cambios específicos, no es el producto indicado. Pero el bono #2 te enseña exactamente cómo personalizarlos sin editar.',
  },
  {
    question: '¿Cuál es la resolución y formato para imprimir?',
    answer:
      '300 DPI, lo que garantiza que se vea nítido en cualquier tipo de impresora (láser, inyección, imprenta profesional). Todos los archivos están en color y listos para papel de 200g+. Formatos: A4 y A3 según corresponda.',
  },
  {
    question: '¿Puedo usarlo en múltiples grupos, escuelas o instituciones?',
    answer:
      'Sí. Una vez que lo compres, podés imprimir las copias que necesites para tu escuela, consultorio, empresa u organización. La licencia personal te lo permite para uso institucional sin límite.',
  },
  {
    question: '¿Qué hago si alguien entra en crisis durante una dinámica?',
    answer:
      'La Guía de Implementación (Bono #1) te prepara exactamente para esto. El protocolo incluye instrucciones de contención en el momento y cómo derivar a un profesional de salud mental si es necesario. Esto no es terapia, es prevención con cuidado y sensibilidad.',
  },
  {
    question: '¿Vale realmente la pena invertir $14.990?',
    answer:
      'Compará: 1 hora de diseño gráfico cuesta $3.000+. 1 sesión de consultoría RRHH cuesta $5.000+. 1 charla profesional sobre salud mental cuesta $8.000+. Vos estás comprando 50 páginas profesionales + 3 bonos (implementación, impresión, comunicación) + guía estratégica por $14.990. Es una inversión de 4-5 horas de trabajo profesional al precio de una comida de negocios.',
  },
]
